function MedispaLocationsFilter() {
  var self = this;

  this.getQueryStringValue = function (key) {
    const urlParams = new URLSearchParams(window.location.search);

    return urlParams.get(key);
  };

  function getLocationProduct(el) {
    const raw = el.getAttribute("data-product");

    try {
      return JSON.parse(raw);
    } catch (e) {
      return raw;
    }
  }

  function updateDropdownData(matchedLocations) {
    const bookingsWrapper = document.querySelector(".booking-wrapper");

    if (!bookingsWrapper) return;

    // Update location-count
    const dropdownTrigger = bookingsWrapper.querySelector(
      ".medispa-dropdown-trigger",
    );

    if (!dropdownTrigger) return;

    dropdownTrigger.setAttribute(
      "data-product-count",
      matchedLocations.length,
    );

    const dropdownOptionsWrapper = bookingsWrapper.querySelector(
      ".medispa-dropdown-options",
    );

    // Replace productData with the new filtered info
    window.productData = [];

    // If only one location is matched, remove .medispa-dropdown-options, remove the dropdown arrow and set data-action="open-calendar", data-product-id="7447575232695", and data-variant-id="42112921174199"
    if (matchedLocations.length === 1) {
      const location = matchedLocations[0];

      window.productData.push(getLocationProduct(location.element));

      if (dropdownOptionsWrapper) dropdownOptionsWrapper.remove();

      const dropdownArrow = dropdownTrigger.querySelector(
        ".Icon--chevron-down-outline",
      );

      if (dropdownArrow) dropdownArrow.remove();

      dropdownTrigger.setAttribute("data-action", "open-calendar");
      dropdownTrigger.setAttribute("data-product-id", location.productId);
      dropdownTrigger.setAttribute("data-variant-id", location.variantId);

      dropdownTrigger.classList.toggle("has-products", false);
      dropdownTrigger.classList.toggle("js-action", true);

      return;
    }

    // If multiple locations are matched, ensure only matching dropdown options are displayed
    if (!dropdownOptionsWrapper) return;

    // Hide all dropdown options
    const locationDropdownOptions = dropdownOptionsWrapper.querySelectorAll(
      "medispa-dropdown-item__hitpoint",
    );

    if (!locationDropdownOptions.length) return;

    locationDropdownOptions.forEach(function (el) {
      el.style.display = "none";
    });

    // Show only matched dropdown options
    matchedLocations.forEach(function (location) {
      location.element.style.display = "";
      window.productData.push(getLocationProduct(location.element));
    });
  }

  this.filterLocations = function (location) {
    const bookingsWrapper = document.querySelector(".booking-wrapper");

    if (!bookingsWrapper) return;

    const dropdownOptionsWrapper = bookingsWrapper.querySelector(
      ".medispa-dropdown-options",
    );

    if (!dropdownOptionsWrapper) return;

    const locationDropdownOptions = dropdownOptionsWrapper.querySelectorAll(
      ".medispa-dropdown-item__hitpoint",
    );

    if (!locationDropdownOptions.length) return;

    // Filter location dropdown options
    const matchedLocations = Array.from(locationDropdownOptions).reduce(
      function (all, elem) {
        const locationOptionText = elem.textContent.toLowerCase();

        if (!locationOptionText.includes(location.toLowerCase())) return all;

        all.push({
          element: elem,
          productId: elem.getAttribute("data-product-id"),
          variantId: elem.getAttribute("data-variant-id"),
        });

        return all;
      },
      [],
    );

    if (!matchedLocations.length) return;

    updateDropdownData(matchedLocations);
  };

  this.init = function () {
    // Check query string for location, if it exists, set the location filter
    var location = self.getQueryStringValue("location");
    if (location) {
      self.filterLocations(location);
    }
  };
}

function initMedispaLocationsFilter() {
  window.medispaLocationsFilter = new MedispaLocationsFilter();
  window.medispaLocationsFilter.init();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMedispaLocationsFilter);
} else {
  initMedispaLocationsFilter();
}
